import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import ProjectComponent from '../components/ProjectComponent';
import ProjectCard from '../components/ProjectCard';

export default function ProjectPage() {
  const { id } = useParams(); // <-- _id desde la ruta
  const [project, setProject] = useState(null);
  const [owners, setOwners] = useState([]);
  const [showEditPopup, setShowEditPopup] = useState(false);

  const userId = localStorage.getItem('userId');
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const canEdit = isAdmin || owners.some((owner) => owner._id === userId);

  useEffect(() => {
    // Aquí haces el fetch a tu backend
    const fetchProject = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project/${id}`);
        const data = await res.json();
        console.log('Proyecto cargado:', data);
        setProject(data);
      } catch (err) {
        console.error('Error cargando proyecto:', err);
      }
    };
    const fetchOwners = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project/${id}/users`);
        const data = await res.json();
        console.log('Owners cargados:', data);
        setOwners(data);
      } catch (err) {
        console.error('Error cargando owners:', err);
      }
    };
    fetchOwners();
    fetchProject();
  }, [id]);

  return (
    <Container className="py-5">
      {project ? (
        <Row>
          <ProjectComponent
            project={project}
            owners={owners}
            canEdit={canEdit}
            onEdit={() => setShowEditPopup(true)}
          />
        </Row>
      ) : (
        <p className="text-center">Cargando proyecto...</p>
      )}

      <ProjectCard
        isOpen={showEditPopup}
        onClose={() => setShowEditPopup(false)}
        project={project}
      />
    </Container>
  );
}
